/* eslint 'jsx-a11y/alt-text': 'off','no-redeclare': 'off', 'no-self-assign' : 'off', eqeqeq: 'off' */
import React, { Component } from 'react';
import { createFilter } from 'react-search-input';
import { Table, Button, Modal, Label, Form, FormGroup, Col } from "reactstrap";
import { connect } from "react-redux";
import AddEquipment from "./AddEquipment";
import { SaveWorkOrderEquipment, GetWorkOrderEquipments, GetWorkOrderBuildings } from '../../../../action/workorderAction';
import DeleteConfirmation from '../../TenantComponents/ManageTenants/_ModalsForms/DeleteConfirmation';
import EditIcon from '../../../../Assets/images/Icons__edit.svg';
import DeleteIcon from '../../../../Assets/images/Icons__trash2.svg';
import ReactPaginate from 'react-paginate';
import LoadingIndicator from '../../Common/LoadingIndicator';

const KEYS_TO_FILTERS = ['name', 'buildingName', 'familyType', 'discovered'];
let pagesCount = 0;
class EquipmentList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isloading: true,
            sort: {
                column: null,
                direction: [
                    { name: 'name', direction: 'asc', onclick: true },
                    { name: 'buildingName', direction: 'desc', onclick: false },
                    { name: 'familyType', direction: 'desc', onclick: false },
                    { name: 'discovered', direction: 'desc', onclick: false }
                ]
            },
            Display: 'EquipmentList',
            searchTerm: "",
            Options_List_Value: [],
            Details: [],
            deletemodal: false,
            currentPage: 0,
            pageSize: 50,
            IsDefaultSort: true
        };
        this.SaveEquipment = this.SaveEquipment.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.CancelEquipment = this.CancelEquipment.bind(this);
        this.CancelEditEquipment = this.CancelEditEquipment.bind(this);
        this.OpenDeletePopup = this.OpenDeletePopup.bind(this);
        this.Delete = this.Delete.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    componentWillMount() {
        this.props.GetWorkOrderEquipments().then(() => {this.setState({isloading: false})});
        this.props.GetWorkOrderBuildings();
    }

    Delete(someArg) {
        if (someArg == "yes") {
            this.DeleteEquiment()
        }
        this.Deletetoggle();
    }

    OpenDeletePopup() {
        this.Deletetoggle();
    }

    Deletetoggle = () => {
        this.setState({
            deletemodal: !this.state.deletemodal
        });
    }

    CancelEditEquipment() {
        this.setState({ Display: 'ViewEquipment' });
    }

    CancelEquipment() {
        this.setState({ Display: 'EquipmentList' });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps && nextProps.getEquipments != undefined && nextProps.getEquipments.length > 0) {
            this.setState({ Options_List_Value: nextProps.getEquipments });
        }
    }

    /* Pagination System */
    handlePageClick = data => {
        let selected = data.selected;
        this.setState({ currentPage: selected });
        var scrollPageTop = (this.props.Premise) ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
        if(scrollPageTop[0] !== undefined){
            (this.props.Premise) ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
        }
    };

    /* Filter System */
    searchUpdated(term) {
        this.setState({ searchTerm: this.refs.equipment_search_value.value })
    }

    OpenAddNewEquipment() {
        this.setState({ Display: 'AddEquipment' });
    }

    SaveEquipment(data) {
        this.props.SaveWorkOrderEquipment(data);
        this.setState({ Display: 'EquipmentList' });
    }

    onSort = (column) => (e) => {
        this.setState({IsDefaultSort:false});
        const SelectedDirectioninfo = this.state.sort.direction.filter(x => x.name == column)[0];
        const direction = SelectedDirectioninfo !== null ? (SelectedDirectioninfo.direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.state.Options_List_Value;
        var notequals = 0;

        if (data_from_state != null) {
            const sortedData = this.state.Options_List_Value.sort((a, b) => {
                var nameA = a[column];
                var nameB = b[column];

                if (isNaN(a[column])) {
                    nameA = a[column].toLowerCase();
                    nameB = b[column].toLowerCase();
                }
                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });

            if (SelectedDirectioninfo.direction == 'asc' && notequals == 1) {
                sortedData.reverse();
            }

            const array = this.state.sort.direction;
            array.map(x => (x.name == column) ? x.onclick = true : x.onclick = false);
            array.map(x => (x.name == column) ? x.direction = direction : x.direction = x.direction);

            this.setState({
                temp_adjustments_list_state: sortedData,
                sort: {
                    column,
                    direction: array,
                }
            });
        }
    };

    ViewEquipmentDetails(detail) {
        this.setState({ Display: 'ViewEquipment', Details: detail });
    }

    MoveToEquipmentList() {
        this.setState({ Display: 'EquipmentList' });
    }

    DeleteEquiment() {
        var LineItem = {
            "Id": this.state.Details.id,
            "Name": this.state.Details.name,
            "SiteId": this.state.Details.siteId,
            "IsDeleted": true
        }

        let Equipments = [];
        Equipments.push(LineItem);
        this.SaveEquipment(Equipments);
    }

    EditEquipment() {
        this.setState({ Display: 'EditEquipment' });
    }

    render() {
        var label = this.props.getLabels;
        var Equipments;
        let lEquipmentlength = 0, lCurrentEquipmentlength = 0;

        if (this.props.getEquipments.length > 0 && !this.state.isloading) {
            if(this.state.IsDefaultSort){
                var data_from_state = this.state.Options_List_Value;
                if (data_from_state != null) {
                    //eslint-disable-next-line
                    const sortedData = this.state.Options_List_Value.sort((a, b) => {
                        var nameA = a['name'];
                        var nameB = b['name'];
        
                        if (isNaN(a['name'])) {
                            nameA = a['name'].toLowerCase();
                            nameB = b['name'].toLowerCase();
                        }
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        if (nameA == nameB) {
                            return 0;
                        }
                        return 0;
                    });
                }
            }
            let FilteredData = this.state.Options_List_Value.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            lEquipmentlength = FilteredData.length;
            pagesCount = Math.ceil(FilteredData.length / this.state.pageSize);
            Equipments = FilteredData.length ? FilteredData.slice(this.state.currentPage * this.state.pageSize, (this.state.currentPage + 1) * this.state.pageSize
            ).map(el => (
                <tr>
                    <td className="link_cursorUnderline" onClick={() => { this.ViewEquipmentDetails(el) }}>{el.name}</td>
                    <td>{el.buildingName}</td>
                    <td>{el.familyType}</td>
                    <td>{el.discovered}</td>
                </tr>
            )) : <tr><td>{label['NoRecords.Text'] !== undefined ? label['NoRecords.Text'] : "No Records Found"}</td></tr>;
            if(Equipments !== undefined && Equipments.length !== undefined)
                lCurrentEquipmentlength = Equipments.length;
        } else if(!this.state.isloading){
            Equipments = <tr><td>{label['NoRecords.Text'] !== undefined ? label['NoRecords.Text'] : "No Records Found"}</td></tr>
        } else{
            Equipments = <tr><td colSpan="4" style={{textAlign: 'center'}}><LoadingIndicator/></td></tr>
        }

        var active_content = "";
        if (this.state.Display == "EquipmentList") {
            active_content = <div className="main_container">
                <div className="row row_padding" style={{'margin-left':'0px','margin-right':'0px'}}>
                    <div className="col-md-12">
                        <label className="workordermainheaderlbl" style={{'margin-top': '4px', 'float': 'left' }}>Non-discovered Equipment</label>
                        <label className="child_tab_paginationtext">{(lEquipmentlength !== 0 ? this.state.currentPage*50+1 : 0) + "-" + ((this.state.currentPage*50)+lCurrentEquipmentlength) + " of " + lEquipmentlength + " records"}</label>
                        <Button className="child_tab_button" style={{'width':'148px'}} onClick={() => { this.OpenAddNewEquipment() }} >{label['Equipment.AddNewEquipment.Text'] !== undefined ? label['Equipment.AddNewEquipment.Text'] : "ADD NEW EQUIPMENT"}</Button>
                        <span className="pm_outersearchbox" style={{ float: 'right' }}>
                            <input type="text" className="pm_searchbox" style={{ paddingLeft: '10px', 'margin-top': '3px' }} placeholder="Enter Value..." onChange={this.searchUpdated} ref='equipment_search_value' />
                        </span>
                        <label style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black', float: 'right', 'margin-top': '4px' }}>{label !== undefined ? label['PreventativeMaintenance.Search.Text'] : "Search:"}</label>
                    </div>
                </div>
                <br/>
                <div className="table_container table_border" style={{'margin-bottom':'0px', 'margin-right':'15px','margin-left':'15px'}}>
                    <Table striped responsive className="Custom_table">
                        <tbody className="cell_container">
                            <tr>
                                <th className="wo_cursor" onClick={this.onSort('name')} >
                                    <span>{label['Equipment.Name.Text']}</span>
                                    <span className={(this.state.sort.direction[0].name == "name") ?
                                        (this.state.sort.direction[0].onclick) ? (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th className="wo_cursor" onClick={this.onSort('buildingName')} >
                                    <span>{label['Equipment.Building.Text']}</span>
                                    <span className={(this.state.sort.direction[1].name == "buildingName") ?
                                        (this.state.sort.direction[1].onclick) ? (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th className="wo_cursor" onClick={this.onSort('familyType')} >
                                    <span>{label['Equipment.FamilyType.Text']}</span>
                                    <span className={(this.state.sort.direction[2].name == "familyType") ?
                                        (this.state.sort.direction[2].onclick) ? (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th className="wo_cursor" onClick={this.onSort('discovered')} >
                                    <span>{label['Equipment.Discovered.Text']}</span>
                                    <span className={(this.state.sort.direction[3].name == "discovered") ?
                                        (this.state.sort.direction[3].onclick) ? (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                            : (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                            </tr>
                            {Equipments}
                        </tbody>
                    </Table>
                </div>
                <div className="row row_padding pm_pagination" style={{'margin-right':'15px'}}>
                    <div className="col-md-7">
                        <ReactPaginate
                        previousLabel={'Prev'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        breakClassName={'break-me pagination_margin'}
                        breakLinkClassName={'pagination_link_color'}
                        pageCount={pagesCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={'pagination pagination_container_margin'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        disabledClassName={'pagination_disable_link'}
                        pageClassName={'pagination_margin'}
                        pageLinkClassName={'pagination_link_color'}
                        previousClassName={'pagination_margin'}
                        previousLinkClassName={'pagination_link_color'}
                        nextClassName={'pagination_margin'}
                        nextLinkClassName={'pagination_link_color'}
                        forcePage={this.state.currentPage}
                        />
                    </div>
                </div>
            </div>
        }
        else if (this.state.Display == "ViewEquipment") {
            active_content = <div className="main_container">
                <Form>
                    <FormGroup row style={{ "margin-bottom": "1px" }}>
                        <Col sm={{ size: 4 }}>
                            <button className="btn btn-gray" onClick={() => { this.MoveToEquipmentList() }} > {"< BACK"} </button>
                        </Col>
                        <Col sm={{ size: 8 }}>
                            <br />
                            <img src={DeleteIcon} className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor" style={{ color: '#676767', valign: 'bottom', 'margin-top': '1px', width: '15px', height: '14px' }} onClick={this.OpenDeletePopup} />
                            <img src={EditIcon} className="dbd_right_icon Ensemble_Icon Ensemble_question_Icon link_cursor" style={{ color: '#676767', 'margin-top': '1px', width: '15px', height: '14px' }} onClick={() => { this.EditEquipment() }} />
                        </Col>
                    </FormGroup>
                    <hr style={{ backgroundColor: '#666666', height: '1px', border: 'none' }} />
                    <FormGroup row>
                        <Col sm={{ size: 10 }}>
                            <Label className='workordermainheaderlbl'>Equipment Details</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 10 }}>
                            <Label className='workorderheaderlbl'>Name</Label><br />
                            <Label className="workorderlbl">{this.state.Details.name}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 10 }}>
                            <Label className='workorderheaderlbl'>Building</Label><br />
                            <Label className="workorderlbl">{this.state.Details.buildingName}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 10 }}>
                            <Label className='workorderheaderlbl'>Family Type</Label><br />
                            <Label className="workorderlbl">{this.state.Details.familyType}</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 10 }}>
                            <Label className='workorderheaderlbl'>Discovered</Label><br />
                            <Label className="workorderlbl">{this.state.Details.discovered}</Label>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        }
        else if (this.state.Display == "EditEquipment") {
            active_content = <AddEquipment onSave={this.SaveEquipment} IsEdit={true} onCancel={this.CancelEditEquipment} details={this.state.Details} />
        }
        else {
            active_content = <AddEquipment onSave={this.SaveEquipment} IsEdit={false} onCancel={this.CancelEquipment} />
        }
        return (
            <div className={this.props.Premise ? "main_container" : "cloud_main_container"}>
                <div className="border_container">
                    {active_content}
                </div>
                <Modal isOpen={this.state.deletemodal} deletemodal={this.deletemodal} className={"ModalContainer short_modal"} >
                    <DeleteConfirmation parentToChildData={["Delete Work Order Equipment", "You are about to delete a work order equipment from the system. Do you want to continue?", "Close Window", "Delete Equipment"]} Delete={this.Delete} />
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getEquipments: state.WorkorderRootReducer.WorkorderEquipments,
        getBuildings: state.WorkorderRootReducer.WorkorderBuildings
    };
};

const mapDispatchToProps = dispatch => {
    return {
        SaveWorkOrderEquipment: (data) => dispatch(SaveWorkOrderEquipment(data)),
        GetWorkOrderEquipments: () => dispatch(GetWorkOrderEquipments()),
        GetWorkOrderBuildings: () => dispatch(GetWorkOrderBuildings())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EquipmentList);
